export enum Level {
  ALL = -Infinity,
  DEBUG = 10,
  INFO = 11,
  WARNING = 12,
  ERROR = 13,
  OFF = +Infinity,
}
